/**
 * LicenseContext
 * Provides a shared license state across all components
 * Prevents multiple API calls by creating a single useLicense instance
 */

import React, { createContext, useContext } from 'react';
import useLicense from '../hooks/useLicense';

const LicenseContext = createContext(null);

/**
 * Provider component that wraps the app
 * Creates a single instance of useLicense and shares it via context
 */
export function LicenseProvider({ children }) {
  const licenseData = useLicense();

  return (
    <LicenseContext.Provider value={licenseData}>
      {children}
    </LicenseContext.Provider>
  );
}

/**
 * Hook to access license context
 * Replaces direct useLicense() calls in components
 */
export function useLicenseContext() {
  const context = useContext(LicenseContext);

  if (!context) {
    throw new Error('useLicenseContext must be used within a LicenseProvider');
  }

  return context;
}
